import React, { useState } from "react";
//import {
//    Box,
//    Stack,
//    Typography,
//    Divider, 
//    IconButton,
//} from "@mui/material";
//import AddIcon from "@mui/icons-material/Add";
//import RemoveIcon from "@mui/icons-material/Remove";
//import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
//import { ButtonMain } from "../Buttons/ButtonMain";
//import { useNavigate } from "react-router-dom"; 
import { useEffect } from "react";
import { showtoast } from '../Utilities/Utilities';

const apiBaseURL = process.env.REACT_APP_API_URL || `${window.location.origin}`;

export const PaymentInfo = (props) => {

    const { finalCart, allCartSummary, handleMakePayment, activePaymentBtn, setIsModalVisible } = props;

    //console.log(finalCart, allCartSummary);
    const [cartSummary, setCartSummary] = useState(allCartSummary);
    const [myFinalCart, setMyFinalCart] = useState(finalCart);
    const [additionalInfo, setAdditionalInfo] = useState("");

    const [showAdditionalInfo, setShowAdditionalInfo] = useState(false);
    const [finalDiscountPerc, setFinalDiscountPerc] = useState(null);
    const [minVoucherCriteria, setMinVoucherCriteria] = useState(false);

    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            if (window.screen.width >= 1280) {
                if (window.scrollY > 50) { // Threshold for adding class
                    setIsScrolled(true);
                } else {
                    setIsScrolled(false);
                }
            }
        };

        window.addEventListener('scroll', handleScroll);

        // Cleanup the event listener on component unmount
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const toggleAdditionalInfo = () => {
        setShowAdditionalInfo(!showAdditionalInfo);
    };

    // Function to handle increment
    const handleIncrement = (e, item, itemID) => {
        e.preventDefault();
        if (itemID > 0) {
            if (myFinalCart.vouchers <= 20) {
                let MyCartSummary = [...cartSummary]
                const index = MyCartSummary.findIndex((rw) => rw.planID === itemID);

                if (index !== -1) {
                    MyCartSummary[index] = { ...MyCartSummary[index], quantity: item + 5 };

                    const request = {
                        planID: MyCartSummary[index].planID,
                        voucherCount: MyCartSummary[index].quantity,
                    }
                    getBulkPurchaseDiscountedPrice(request, MyCartSummary);
                }
                //setCartSummary(MyCartSummary);
                //updateAdditionlInfo(MyCartSummary);
            }
            else {
                //showtoast("error", "Maximum 25 vouchers are allowed.");
                //return;
                setIsModalVisible(true);
            }
        }

        //setVouchers((prev) => ({ ...prev, [item]: prev[item] + 1 }));
    };

    // Function to handle decrement
    const handleDecrement = (e, item, itemID) => {
        e.preventDefault();

        if (itemID > 0) {
            if (myFinalCart.vouchers >= 15) {
                let MyCartSummary = [...cartSummary]
                const index = MyCartSummary.findIndex((rw) => rw.planID === itemID);

                if (index !== -1) {
                    MyCartSummary[index] = { ...MyCartSummary[index], quantity: item > 0 ? item - 5 : 0 };

                    const request = {
                        planID: MyCartSummary[index].planID,
                        voucherCount: MyCartSummary[index].quantity,
                    }
                    //setCartSummary(MyCartSummary);
                    //updateAdditionlInfo(MyCartSummary);
                    getBulkPurchaseDiscountedPrice(request, MyCartSummary);
                }
                //setVouchers((prev) => ({
                //    ...prev,
                //    [item]: prev[item] > 0 ? prev[item] - 1 : 0, // Prevent negative values
                //}));
            }
            else {
                const { quantity } = cartSummary.find(item => item.planID === itemID);

                if (quantity && quantity !== 0) {
                    showtoast("error", "Minimum 10 vouchers are allowed.");
                    return;
                }
            }
        }
    };

    const getBulkPurchaseDiscountedPrice = (req, cartSummaryData) => {

        const request = cartSummaryData && cartSummaryData.length > 0 &&
            cartSummaryData.map((item) => {
                const data = {
                    SubscriptionPlanID: item.planID,
                    Quantity: item.quantity,
                    PlanAmount: item.subscriptionAmount
                }
                return data;
            })

        fetch(`${apiBaseURL}/api/FriendAndFamily/GetWatchoFFPlanAggregateDiscountInfo`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(request)
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(resultInfo => {
                //console.log("API Response BulkPurchaseDiscount:", resultInfo);

                if (resultInfo && resultInfo.resultStatus === "Success") {
                    //resultInfo.result = { ...resultInfo.result }//, planName: planSummary.planName, PlanID: planSummary.planID }
                    //setPlanPriceDetails(resultInfo.result);

                    //let MyCartSummary = [...cartSummaryData]
                    //const index = MyCartSummary.findIndex((item) => item.planID === resultInfo.result.planID);

                    //if (index !== -1) {
                    //    MyCartSummary[index] = { ...MyCartSummary[index], ...resultInfo.result };
                    //}
                    //else {
                    //    MyCartSummary.push(resultInfo.result);
                    //}

                    handleFinalCart(resultInfo.result);
                    setCartSummary(resultInfo.result);
                    updateAdditionlInfo(resultInfo.result);
                    //setCartSummary(MyCartSummary);
                    //updateAdditionlInfo(MyCartSummary);
                }
                else if (resultInfo && resultInfo.resultStatus !== "Success" ) {
                    showtoast("error", resultInfo.resultMessage);
                }
            })
            .catch(err => {
                console.error("Error calling planPrice API:", err);
                //setError(err); 
            });
    };

    const handleFinalCart = (MyCartSummaryData) => {
        let totalVoucher = 0;
        let desc = "";
        let totalPrice = 0;
        let totalDiscount = 0;
        let totalAmount = 0;

        if (MyCartSummaryData.length > 0) {
            MyCartSummaryData.forEach((data) => {
                totalVoucher += data.quantity
                desc = desc.length > 0 ? desc + " + " : "";
                desc = desc + `${data.quantity} ${data.subscriptionPlanName} ${data.discountPercentage > 0 ? `(${data.discountPercentage}% off)` : ""}`;
                totalPrice = data.finalAggrTotal;
                totalDiscount = data.finalAggrTotalDiscount;
                totalAmount = data.totalAggrWithoutDiscount;
            });
            let finalCartsummary = {
                vouchers: totalVoucher,
                cartDesc: desc,
                cartValue: totalPrice,
                totalDiscount: totalDiscount,
                totalAmount: totalAmount
            }
            setMyFinalCart({ ...myFinalCart, ...finalCartsummary });

            //let discountPer = finalCartsummary.totalDiscount * 100 / (finalCartsummary.cartValue + finalCartsummary.totalDiscount); 
            //discountPer = parseFloat(discountPer.toFixed(2));
            //setFinalDiscountPerc(discountPer);

            //console.log(MyCartSummaryData);
            //console.log({ ...myFinalCart, ...finalCartsummary });

        }
    }

    const updateAdditionlInfo = (MyCartSummary) => {
        let addInfo = "";
        MyCartSummary && MyCartSummary.forEach((data) => {
            //₹ 299 x 10 +  ₹ 229 X 10 + ₹ 309 X 10
            addInfo = addInfo.length > 0 ? addInfo + " + " : "";
            addInfo += `₹${data.subscriptionAmount} x ${data.quantity}`;
        })
        setAdditionalInfo(addInfo);
    }

    useEffect(() => {
        if (additionalInfo.length <= 0) {
            updateAdditionlInfo(allCartSummary);
        }

        if (myFinalCart && myFinalCart.vouchers >= 10 && myFinalCart && myFinalCart.vouchers <= 25) {
            setMinVoucherCriteria(true);
        }
        else {
            setMinVoucherCriteria(false);
        }

        /*let discountPer = myFinalCart.totalDiscount * 100 / (myFinalCart.cartValue + myFinalCart.totalDiscount);*/
        let discountPer = myFinalCart ? myFinalCart.totalDiscount * 100 / (myFinalCart.totalAmount) : 0;
        discountPer = Math.round(discountPer); //parseFloat(discountPer.toFixed(2));
        setFinalDiscountPerc(discountPer);
        //console.log("1", cartSummary);
        //console.log("2", myFinalCart); 
    }, [cartSummary, myFinalCart, additionalInfo, allCartSummary, finalDiscountPerc]);



    return (
        //<Box
        //    sx={{
        //        //width: 300,
        //        padding: "24px 64px",
        //        backgroundColor: "#1E1E1E",
        //        height:"100%"
        //        //borderRadius: 2,
        //        //color: "#FFFFFF",
        //    }}
        //>
        //    {/* Order Summary */}
        //    <Typography variant="subtitle2" sx={{ color: "#A0A0A0" }}>
        //        Order Summary
        //    </Typography>
        //    <Typography variant="body2" sx={{ color: "#D0D0D0", marginBottom: 2 }}>
        //        You are paying for the selected plan(s) coupon vouchers.
        //    </Typography>

        //    {/* Vouchers List */}
        //    <Stack spacing={1}>
        //        {
        //        //    [
        //        //    { label: "Watcho Max", value: "watchoMax" },
        //        //    { label: "Watcho Flexi 3", value: "watchoFlexi3" },
        //        //    { label: "Watcho South Max", value: "watchoSouthMax" },
        //        //]
        //            allCartSummary.map((item) => (
        //            <Stack
        //                key={item.PlanID}
        //                direction="row"
        //                alignItems="center"
        //                justifyContent="space-between"
        //            >
        //                    <Typography variant="body2">{item.planName}</Typography>
        //                <Stack direction="row" alignItems="center" spacing={1}>
        //                        <IconButton size="small" onClick={() => handleDecrement(item.PlanID)}>
        //                        <RemoveIcon sx={{ color: "#FFFFFF" }} />
        //                    </IconButton>
        //                    <Typography variant="body2" sx={{ marginX: 1 }}>
        //                            {item.quantity}
        //                    </Typography>
        //                        <IconButton size="small" onClick={() => handleIncrement(item.PlanID)}>
        //                        <AddIcon sx={{ color: "#FFFFFF" }} />
        //                    </IconButton>
        //                </Stack>
        //            </Stack>
        //        ))}
        //    </Stack>

        //    {/* Number of Vouchers */}
        //    <Divider sx={{ marginY: 2, borderColor: "#444" }} />
        //    <Stack direction="row" justifyContent="space-between">
        //        <Typography variant="body2" sx={{ color: "#A0A0A0" }}>
        //            No. of Vouchers
        //        </Typography>
        //        <Typography variant="body2">{finalCart.vouchers}</Typography>
        //    </Stack>

        //    {/* Payment Summary */}
        //    <Typography variant="subtitle2" sx={{ marginTop: 3, color: "#A0A0A0" }}>
        //        Payment Summary
        //    </Typography>
        //    <Divider sx={{ marginBottom: 1, borderColor: "#444" }} />

        //    <Stack spacing={1}>
        //        <Stack direction="row" justifyContent="space-between" alignItems="center">
        //            <Typography variant="body2">Package Amount</Typography>
        //            <Stack direction="row" alignItems="center" spacing={0.5}>
        //                <Typography variant="body2">₹{finalCart.cartValue + finalCart.totalDiscount}</Typography>
        //                <InfoOutlinedIcon fontSize="smallest" sx={{ color: "#FF4C4C" }} onClick={()=>toggleAdditionalInfo() } />
        //            </Stack>
        //        </Stack>
        //        {showAdditionalInfo && (<p className="addtional-price-info">Additional info</p>)}
        //        <Stack direction="row" justifyContent="space-between">
        //            <Typography variant="body2">{discountPercentage}% Discount</Typography>
        //            <Typography variant="body2">-₹{finalCart.totalDiscount}</Typography>
        //        </Stack>
        //        <Divider sx={{ borderColor: "#444" }} />
        //        <Stack direction="row" justifyContent="space-between">
        //            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        //                Total Payment
        //            </Typography>
        //            <Typography variant="h6" sx={{ fontWeight: "bold" }}>
        //                ₹{finalCart.cartValue}
        //            </Typography>
        //        </Stack>
        //    </Stack>

        //    {/* Make Payment Button */}
        //    {/*<Button*/}
        //    {/*    variant="contained"*/}
        //    {/*    fullWidth*/}
        //    {/*    sx={{*/}
        //    {/*        marginTop: 2,*/}
        //    {/*        backgroundColor: "#C0C0C0",*/}
        //    {/*        color: "#000",*/}
        //    {/*        "&:hover": {*/}
        //    {/*            backgroundColor: "#D0D0D0",*/}
        //    {/*        },*/}
        //    {/*    }}*/}
        //    {/*    onClick={() => gotToCustomerInfo()*/}
        //    {/*    }            >*/}
        //    {/*    Make Payment*/}
        //    {/*</Button>*/}
        //    <ButtonMain text="Try Again" width={"fullWidth"} btnClick={ gotToCustomerInfo } />
        //</Box>

        <div className={`col-lg-5 friendsFamily order-summary ${isScrolled ? 'scrolled' : ''}`}>
            <h5 className="Order-Summary-new">Order Summary</h5>
            <p className="orderSummaryCaption">You are paying for the selected plan(s) coupon vouchers.</p>
            <hr className="my-line" />
            <ul className="list-unstyled">
                {cartSummary && cartSummary.length > 0 && cartSummary.map((item, idx) => (
                    <li key={idx} className="d-flex justify-content-between">
                        <span className="watcho-mex"> {item.subscriptionPlanName} </span>
                        <div className="flx-div">
                            <span className="watcho-mex sub-img small" onClick={(e) => handleDecrement(e, item.quantity, item.planID)}>
                                <img src="/Images/subb-img.png" alt="Subtract" className="img-fluid sib-img" />
                            </span>
                            <div className="watcho-mex-ten">{item.quantity}</div>
                            <span className="watcho-mex add-img small" onClick={(e) => handleIncrement(e, item.quantity, item.planID)}>
                                <img src="/Images/add-img.png" alt="Add" className="img-fluid sib-img" />
                            </span>
                        </div>
                    </li>
                ))}
            </ul>
            <hr className="my-line" />
            <div className="mt-3">
                <h5 className="d-flex justify-content-between">No. of Vouchers <span id="total-vouchers" style={{ paddingRight: '29px' }}>{myFinalCart && myFinalCart.vouchers}</span></h5>

                <p className="payment-summary">Payment Summary</p>
                <hr className="my-line" />
                <div className="d-flex justify-content-between mb-2">
                    <span className="watcho-mex">Package Amount</span>
                    <span className="watcho-mex">₹ {myFinalCart && myFinalCart.totalAmount}</span>
                </div>

                <div style={{ position: 'relative' }} onClick={toggleAdditionalInfo} >
                    <img src="/Images/info-icon.svg" alt="My Logo" className="img-fluid info-icon" />
                </div>

                <>
                    {showAdditionalInfo && (
                        <div style={{ position: 'relative' }} >
                            <span className="rate-killa">{additionalInfo}</span>
                        </div>
                    )}
                </>
                <div className="d-flex justify-content-between">
                    <span className="watcho-mex">{myFinalCart && myFinalCart.totalDiscount > 0 ? finalDiscountPerc : 0}% Discount</span>
                    <span className="watcho-mex">-₹ {myFinalCart && myFinalCart.totalDiscount}</span>
                </div>
                <hr className="my-line" />
                <div className="d-flex justify-content-between">
                    <span className="tottal-ayment">Total Payment</span>
                    <span className="tottal-ayment">₹ {myFinalCart && myFinalCart.cartValue}</span>

                </div>
                <hr className="my-line" />
            </div>
            {/*<button className="bttn-make-payment" style={{ display: 'none' }} >Make Payment</button>*/}
            {/*<button className="bttn-make-payment-grey" disabled>Make Payment</button>*/}
            <div className="paymentBtnWrapper">
                {myFinalCart && myFinalCart.cartValue > 0 && activePaymentBtn && minVoucherCriteria ?
                    <button className="bttn-make-payment" onClick={() => handleMakePayment(cartSummary, myFinalCart)}>Make Payment</button>
                    : <button className="bttn-make-payment-grey" disabled>Make Payment</button>
                }
            </div>
        </div>
    );
}

